import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { AmazonRdsForOracleLinkedService } from '../linkedservice/amazon-rds-for-oracle.linkedservice';


@Metamodel.model({
    name: adfModelTypeMap.amazonRdsForOracle.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AmazonRdsForOracle_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AmazonRdsForOracle_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AmazonRdsForOracleLinkedService.MODEL
        }
    }
})
export class AmazonRdsForOracleDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
